import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

// import { deviceLayout } from 'styles/breakpoint'

export const StyledSpotlightsWrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(4, 1fr);
  overflow: visible;
  margin-bottom: 80px;
  ${MediaQueries.tdOnly} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
  }
  ${MediaQueries.mbDown} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
  }
  > a {
    justify-self: center;
  }
`
